import React, { DragEvent, FunctionComponent, useRef, useState } from 'react';
import Button from 'ui/atoms/button';
import Translate from 'ui/atoms/translate';
import * as Styled from './styled';
import Icon from 'ui/atoms/icon';
import Spacer from 'ui/atoms/spacer';
import FileUploadDocumentContainer from './file-upload-document-container';
import FileUploadDocumentType from './file-upload-document-type';

export interface FileToUpload {
  file: File | null;
  documentType?: string;
}

export interface FileWithDocType {
  file: Blob | null;
  documentType: string | null;
}

export type FileType = 'pdf' | 'image';

export const FileUpload: FunctionComponent<{
  handleFileInput: (event: any) => void;
  uploadedFiles: FileToUpload[];
  onRemoveDocument: (fileName?: string) => void;
  documentTypes?: Array<any>;
  onSelectDocumentType?: (documentType: string, fileName?: string) => void;
  showRequiredError?: boolean;
  showValidatedForm?: boolean;
  fileType?: FileType;
}> = ({
  uploadedFiles,
  handleFileInput,
  onRemoveDocument,
  documentTypes,
  onSelectDocumentType,
  showRequiredError,
  showValidatedForm,
  fileType = 'pdf',
}) => {
  const fileInput = useRef<any>(null);

  const [isFileDragged, setIsFileDragged] = useState(false);

  const getAcceptFileTypes = () => {
    return fileType === 'pdf' ? '.pdf' : 'image/*';
  };

  const handleFileDrop = (event: any) => {
    event.preventDefault();
    setIsFileDragged(false);
    handleFileInput && handleFileInput(event);
  };

  return (
    <>
      <form method="post" action="" encType="multipart/form-data">
        <Styled.FileUploadContainer
          $dragOver={isFileDragged}
          $error={showRequiredError}
          onDragLeave={() => setIsFileDragged(false)}
          onDragOver={(event: DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            setIsFileDragged(true);
          }}
          onDrop={handleFileDrop}
        >
          <input
            className="box__file"
            type="file"
            onChange={handleFileInput}
            onClick={(event: any) => {
              event.target.value = null;
            }}
            accept={getAcceptFileTypes()}
            id="file"
            hidden={true}
            ref={fileInput}
          />
          <Styled.TextContent>
            <Icon size="large" name="upload" color="primary" />
            <Spacer y={4} />
            <Translate
              name={fileType === 'pdf' ? 'uploadPdf.dragDropButton' : 'uploadImage.dragDropButton'}
              as="div"
              args={[
                (text, key) => (
                  <Button
                    variant="link"
                    onClick={() => fileInput?.current && fileInput.current.click()}
                    key={key}
                    inline
                  >
                    {text}
                  </Button>
                ),
              ]}
            />
            <Spacer y={2} />
            <Styled.SideTextContent>
              <Translate
                name="uploadPdf.fileSize"
                as="span"
                args={[
                  (text) => (
                    <label htmlFor="file">
                      {' '}
                      <b>{text}</b>
                    </label>
                  ),
                ]}
              />
            </Styled.SideTextContent>
          </Styled.TextContent>
        </Styled.FileUploadContainer>
      </form>
      <Spacer y={2} />
      {!!uploadedFiles?.length &&
        uploadedFiles.map((uploadedFile) => {
          if (!uploadedFile?.file?.name) return null;

          return (
            <>
              <FileUploadDocumentContainer uploadedFile={uploadedFile} onRemoveDocument={onRemoveDocument} />
              <FileUploadDocumentType
                uploadedFile={uploadedFile}
                documentTypes={documentTypes}
                showValidatedForm={showValidatedForm}
                onSelectDocumentType={onSelectDocumentType}
              />
              <Spacer y={2} />
            </>
          );
        })}
    </>
  );
};

export default FileUpload;
